import { uid } from "../Storage.js";

/**
 * Clone any object and it's properties recursively.
 * Not a true deep clone, but only created to be able to clone
 * data object records and parameters.
 *
 * @param {T} object - Object to clone
 * @returns {T} Clone of object
 */
export default function naiveDeepClone<T>(object: T): T {
	let objUid: any;
	if (typeof object === "object" && object) {
		objUid = (object as any)[uid];
	}

	if (globalThis.structuredClone) {
		let cloned = globalThis.structuredClone(object);
		if (objUid) (cloned as any)[uid] = objUid;
		return cloned;
	}

	if (object instanceof Date) {
		return new Date(object.getTime()) as unknown as T;
	} else if (object == null) {
		return object;
	} else if (Array.isArray(object)) {
		return object.map(naiveDeepClone) as unknown as T;
	} else if (typeof object === "object") {
		let newObject = {} as any;
		for (let key of Object.keys(object)) {
			newObject[key] = naiveDeepClone((object as any)[key]);
		}

		if (objUid) newObject[uid] = objUid;

		return newObject as T;
	}

	return object;
}
